"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windOptions = exports.wind = void 0;
exports.wind = ['Unknown or Not Given', 'None', 'Light Breeze', 'Windy', 'Strong Wind'];
exports.windOptions = new Set(exports.wind.map(function (option) { return ({
    text: option,
    value: option,
}); }));
